"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Uuids = void 0;
function Uuids(items) {
    return items.map((item) => {
        return item.uuid;
    });
}
exports.Uuids = Uuids;
